import styled from "@emotion/styled";
import { TableCell, TableCellProps, Typography, TypographyProps } from "@kaltura/ds-react-components";
import { TruncatedLine } from "../truncate/TruncatedLine";

export interface TruncatedContentTableCellProps extends TableCellProps {
    typographyProps?: TypographyProps;
}

/**
 * Table cell that takes all available space, and truncates the contents with ellipsis.
 */
export const TruncatedContentTableCell = ({
    typographyProps,
    children,
    ...cellProps
}: TruncatedContentTableCellProps) => {
    return (
        <StyledCell {...cellProps}>
            <ShrinkTypography variant={"body2"} {...typographyProps}>
                <TruncatedLine>{children}</TruncatedLine>
            </ShrinkTypography>
        </StyledCell>
    );
};

const StyledCell = styled(TableCell)({
    position: "relative",
});

const ShrinkTypography = styled(Typography)({
    position: "absolute",
    inset: 0,
    marginTop: "auto",
    marginBottom: "auto",
    height: "fit-content",
    padding: "inherit",
});
